import {Plural, Trans} from '@lingui/react/macro'

import {
  type CommonNavigatorParams,
  type NativeStackScreenProps,
} from '#/lib/routes/types'
import {nameSegmentToIdentifier} from '#/lib/strings/profile-path'
import {makeRecordUri} from '#/lib/strings/url-helpers'
import {usePostQuery} from '#/state/queries/post'
import {PostLikedBy as PostLikedByComponent} from '#/view/com/post-thread/PostLikedBy'
import * as Layout from '#/components/Layout'

type Props =
  | NativeStackScreenProps<CommonNavigatorParams, 'PostLikedBy'>
  | NativeStackScreenProps<CommonNavigatorParams, 'PostByNameLikedBy'>
export const PostLikedByScreen = ({route}: Props) => {
  const {rkey} = route.params
  const name =
    route.name === 'PostByNameLikedBy'
      ? // AtUri throws synchronously on an empty/malformed host, so an
        // unresolvable segment falls back to the same sentinel
        // isInvalidHandle() already recognizes, rather than '' - the
        // resulting failed resolution is handled the same way any other
        // nonexistent handle already is.
        (nameSegmentToIdentifier(route.params.name) ?? 'handle.invalid')
      : route.params.name
  const uri = makeRecordUri(name, 'app.bsky.feed.post', rkey)
  const {data: post} = usePostQuery(uri)

  let likeCount
  if (post) {
    likeCount = post.likeCount
  }

  return (
    <Layout.Screen>
      <Layout.Header.Outer>
        <Layout.Header.BackButton />
        <Layout.Header.Content>
          {post && (
            <>
              <Layout.Header.TitleText>
                <Trans>Liked By</Trans>
              </Layout.Header.TitleText>
              <Layout.Header.SubtitleText>
                <Plural value={likeCount ?? 0} one="# like" other="# likes" />
              </Layout.Header.SubtitleText>
            </>
          )}
        </Layout.Header.Content>
        <Layout.Header.Slot />
      </Layout.Header.Outer>
      <PostLikedByComponent uri={uri} />
    </Layout.Screen>
  )
}
